import Card from "@ciq/shared/components/card"
import { useOverlayData } from "./useOverlayData"
import { EmptyView } from "@ciq/shared/components/views"
import { NO_DATA_AVAILABLE_MESSAGE } from "@ciq/shared/utils/const"

export function Legend() {
  const { legendData } = useOverlayData()

  if (!legendData) {
    return null
  }

  return (
    <Card className="legend-card utilization">
      <span className="legend-title">{legendData.name}</span>
      {legendData.hasData === false ? (
        <EmptyView>{NO_DATA_AVAILABLE_MESSAGE}</EmptyView>
      ) : (
        <div className="legend-content">
          {legendData.colors.map(color => (
            <LegendRow key={color.id} item={color} />
          ))}
        </div>
      )}
    </Card>
  )
}

function LegendRow({ item }) {
  return (
    <>
      <LegendColor color={item.color} />
      <span>{item.title}</span>
      <span className="text-align-right">{item.range}</span>
    </>
  )
}

function LegendColor({ color, ...props }) {
  const { className, style, ...rest } = props

  const classNames = ["legend-color"]
  if (className != null) classNames.push(className)

  const classStyle = {
    backgroundColor: color,
    ...(style || {}),
  }

  return <p className={classNames.join(" ")} style={classStyle} {...rest} />
}
